import { render } from "./FixedCostList.vue?vue&type=template&id=2e22787a&scoped=true"
import script from "./FixedCostList.vue?vue&type=script&lang=js"
export * from "./FixedCostList.vue?vue&type=script&lang=js"

import "./FixedCostList.vue?vue&type=style&index=0&id=2e22787a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e22787a"]])

export default __exports__